import {useMemo} from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {DEFAULT_DATE_FORMAT} from '../../constants/reports';
const dateFns = new DateFnsUtils();

// simple util that contains shared logic for initial report date ranges
export function useDefaultReportRange() {
    const today = useMemo(()=>new Date(), []);
    const initial = useMemo(()=>({
        startDate: dateFns.startOfMonth(today),
        endDate: today,
    }), [today]);
    const formatted = useMemo(()=>({
        startDateStr: dateFns.format(initial.startDate, DEFAULT_DATE_FORMAT),
        endDateStr: dateFns.format(initial.endDate, DEFAULT_DATE_FORMAT),
    }), [initial]);
    return {
        ...initial,
        ...formatted,
        today,
    };
}
